module.exports = __webpack_public_path__ + "img/biweekly-patch.915293d9.svg";